import { useForm } from '@inertiajs/react'
import type { FormEvent } from 'react'
import Layout, { Card } from '@/components/Layout'
import { Field, SubmitButton } from '@/components/AuthShell'

export default function Edit({ email_address }: { email_address: string }) {
  const pwForm = useForm({ password_challenge: '', password: '', password_confirmation: '' })

  const savePassword = (e: FormEvent) => {
    e.preventDefault()
    pwForm.patch('/account', {
      preserveScroll: true,
      onSuccess: () => pwForm.reset(),
    })
  }

  return (
    <Layout>
      <Card title="⚙️ 账号">
        <div className="grid gap-1.5 max-w-[360px]">
          <span className="text-sm font-semibold text-[#1b2330]">登录邮箱</span>
          <div className="border border-[#e7ebf2] rounded-[10px] px-3 py-2.5 bg-[#f4f6fb] text-[#707d90]">{email_address}</div>
          <span className="text-[13px] text-[#707d90]">登录邮箱作为账号身份，不可修改。</span>
        </div>
      </Card>

      <Card title="🔒 修改密码">
        <form onSubmit={savePassword} className="grid gap-4 max-w-[360px]">
          <Field
            label="当前密码"
            type="password"
            autoComplete="current-password"
            required
            value={pwForm.data.password_challenge}
            error={pwForm.errors.password_challenge}
            onChange={(e) => pwForm.setData('password_challenge', e.target.value)}
          />
          <Field
            label="新密码"
            type="password"
            autoComplete="new-password"
            required
            maxLength={72}
            placeholder="至少 8 位"
            value={pwForm.data.password}
            error={pwForm.errors.password}
            onChange={(e) => pwForm.setData('password', e.target.value)}
          />
          <Field
            label="确认新密码"
            type="password"
            autoComplete="new-password"
            required
            maxLength={72}
            value={pwForm.data.password_confirmation}
            error={pwForm.errors.password_confirmation}
            onChange={(e) => pwForm.setData('password_confirmation', e.target.value)}
          />
          <SubmitButton disabled={pwForm.processing}>{pwForm.processing ? '提交中…' : '修改密码'}</SubmitButton>
        </form>
      </Card>
    </Layout>
  )
}
